export default __webpack_public_path__ + "static/Dosis-Light-930473df1104bf9ffdf61a60b62b3524.woff2";